module.exports = __webpack_public_path__ + "img/qrcode.2136df30.jpg";